// ABOUTME: Software Orders overview page for SHA admin users.
// ABOUTME: Full-bleed shell (tertiary background + paddingTop) hosting the cross-customer overview.

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import All from "./views/All";

const SoftwareOrders = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box sx={{ background: colors.bg["tertiary"], width: 1, minHeight: "100vh", paddingTop: 9, display: "flex", flexDirection: "column" }}>
            <All />
        </Box>
    );
};

export default SoftwareOrders;
